import * as types from './mutation-types'

const matutaions = {
  [types.SET_USER] (state, user) {
    state.user = user
  }
}

export default matutaions



// WEBPACK FOOTER //
// ./src/store/mutations.js